import clinicalEventConfirmAlert from '../clinicalEventConfirmAlert';

function confirmAmend({ onClick }: { onClick: () => void }) {
  clinicalEventConfirmAlert({
    title: 'Amend event',
    body: `You're about to amend this event .`,
    onClick,
    primaryBtnText: 'Amend'
  });
}

export default confirmAmend;
